import { useCallback, useState } from 'react'

/**
 * A counter that moves on every user edit and on nothing else, for a guided
 * grid's autosave `version`.
 *
 * The grids used to arm the autosave on a sum of their staged-list sizes.
 * That sum does not move when a staged row is edited again, and can cancel
 * out (a fix that adds an edit and clears a refusal mark), so a corrected row
 * never saved; and the save's own changes to those lists re-armed it into
 * sending a refused row once more. Moved by the user only, a refusal cannot
 * re-arm itself (SCRUM-1032).
 */
const useUserEditVersion = () => {
  const [version, setVersion] = useState(0)
  const noteUserEdit = useCallback(() => setVersion((value) => value + 1), [])
  return [version, noteUserEdit] as const
}

export default useUserEditVersion
